import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { DepartmentService } from '../proxy/planning/controllers/department.service';
import { LocalityTypeService } from '../proxy/planning/controllers/locality-type.service';

FieldBuilder.setNamespace('Planning');

export const LOCALITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Locality.Name')
    .required()
    .maxLength(80)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Locality.Code')
    .maxLength(8)
    .build(),
  FieldBuilder
    .number('mtopCityId', 'Entity.Locality.MtopCity')
    .build(),
  FieldBuilder
    .foreignKey('departmentId', 'Entity.Department', DepartmentService)
    .required()
    .displayFromNested('department.name')
    .sortBy('department.name')
    .build(),
  FieldBuilder
    .foreignKey('localityTypeId', 'Entity.LocalityType', LocalityTypeService)
    .required()
    .displayFromNested('localityType.name')
    .sortBy('localityType.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const LOCALITY_CONFIG = {
  entityName: 'Locality',
  localizationKey: 'Planning::Entity.Locality',
  permission: 'PlanningGeography.Localities',
  fields: LOCALITY_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
